import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Button } from 'components/common/Button';
import queryString from 'query-string';

type OrderNumber = string;

export const generateOrderNumber = (): OrderNumber => {
  const orderNumber = new Date()
    .getTime()
    .toString();
  return `JP${orderNumber}`;
};

type OrderParams = {
  orderNumber: string
};

const OrderPage = () => {
  const { search } = useLocation();
  const params = queryString.parse(search);
  const { orderNumber } = useParams<OrderParams>();

  return <div className='p-16'>
    <div id='order-success-message' className='p-4'>
      {params.name && <>
        <strong>Thanks {params.name}</strong>, your order has been accepted. Your order number is {orderNumber}.
      </>}
      {!params.name && <>Your order has been accepted. Your order number is {orderNumber}.</>}
    </div>
    <div className='p-4'>
      <Button id='shop-again-button' primary linkTo='/shop'>Shop Again</Button>
    </div>
    <div
      id='any-problems-message'
      className='pt-16'
    >
      <>Any problems?</>
      <Button className='ml-4' id='contact-us-button' warning linkTo='/contact'>Contact Us</Button>
    </div> 
  </div>;
};

export default OrderPage;
